module.exports = __webpack_public_path__ + "media/components/signup/static/surf_image_1-d71bd07d8406e9a9f69fa419e75d7e5e.jpg";